<template>
    <div style="background: #fbfbfb; padding-bottom: 40px">
      <div class="soluBanner">
        <el-carousel indicator-position="none" :interval="5000" :height="imgHeight + 'px'">
          <el-carousel-item v-for="(item, index) in bannerList" :key="index">
            <a v-if="item.linkUrl" :href="item.linkUrl" target="_blank">
              <img :src="item.value" alt="" style="width: 100%" ref="image" />
            </a>
            <a v-else href="javascript:void(0)">
              <img :src="item.value" alt="" style="width: 100%" ref="image" />
            </a>
          </el-carousel-item>
        </el-carousel>
      </div>
      <div class="soluBottomRTit flex">
        <!-- <div class="soluBottomRFlex flex">
          <div class="soluBottomRTit2">
            <p>案例管理</p>
          </div>
        </div> -->
        <div class="soluBottomInput">
          <div class="soluBottomRTit2 gray soluRightBtn">
            <p>当前位置：</p>
            <p @click="$router.push('/')" class="solutHome">首页 /</p>
            <p class="solutionTitle">赋能案例</p>
          </div>
        </div>
      </div>

      <div class="soluBottom ">
        <div class="soluBottomL">
          <div class="soluBottomLtab">
            <p v-for="(items, index) in soluLeft" :key="index" @click="getSoluTbas(index)">
              <span :class="soluTabsIndex == index ? 'p_active' : ''">{{
                items.title
              }}</span>
            </p>
          </div>
        </div>

        <div class="soluBottomR">
          <div class="suluBottomBig" v-if="solutionList.length != 0">
            <div class="soluBottomRList flex-col" v-for="(items, index) in solutionList" :key="index"
              @click="getSolutionDetail(items.uuid)">
              <div class="soluBottomRImg">
                <img :src="items.thumbnailUrl" alt="" />
              </div>
              <div class="soluBottomRMess">
                <h4>{{ items.name }}</h4>
                <p class="soluBottomRMess_p">
                  {{ items.summary }}
                </p>
                <!-- <div class="flex soluBottomRMess_div">
                  <span>{{ items.createTime }}</span>
                  <div class="flex soluBottomRMess_div2">
                    <i class="iconfont">&#xe611;</i>
                    <span>{{ items.viewNum }}</span>
                  </div>
                </div> -->
              </div>

            </div>
          </div>
          <div v-else class="suluBottomBig2">
            <!-- 暂无数据 -->
            <img src="../../assets/nosearchMesg.jpg" style="width: 200px;" />
          </div>
          <!-- 分页 -->
          <div class="pageina" v-if="solutionList.length != 0">
            <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="current"
              :page-sizes="[10, 20, 50, 100]" :page-size="pageSize" layout="prev, pager, next" :total="total">
            </el-pagination>
          </div>
        </div>
      </div>
    </div>
  </template>

  <script>
  import {
    getProgramList,
    getSolutionList,
    getBannerList,
  } from "../../utils/interface";
  import { mapState } from "vuex";

  export default {
    //   解决方案
    name: "solution",
    metaInfo: {
      title: "赋能案例-水泵云", // set a title
      meta: [
        {
          // set meta
          name: "keywords",
          content:
            "工业互联网 | 智能制造 | 水泵制造 | 水泵解决方案 | 生产制造 | 运维服务 | 水泵打印原理",
        },
        {
          // set meta
          name: "description",
          content:
            "水泵云面向水泵制造领域业务场景，提供整套行业和技术解决方案，为行业用户提供需求发布、设计、建模、打印、交流互动于一体的多种应用场景服务。",
        },
      ],
    },
    components: {},
    data() {
      return {
        imgHeight: "",
        imgHeightsetIn: null,
        groupCode: "CASE_BANNER", // 类别
        survival: "ENABLE", // 状态(ENABLE:启用;DISABLE:停用;VERIFY:验证中;)
        current: 1, // 起始页
        pageSize: 10, // 分页条数
        programUuid: "", // 类别id
        programName: "", // 类别名称
        status: "RELEASE", // 状态(HIDE:隐藏;DRAFT:草稿;RELEASE:发布;)
        soluLeft: [],
        solutionList: [],
        // 分页
        currentPage4: 1,
        total: 0,
        soluTabsIndex: 0,
        // banner列表
        bannerList: [],
        solutionTitle: "全部",
        timer: null,
        setIn: null,
        searchtitle: "",
      };
    },
    created() {
      this.searchtitle = this.$route.query.solutionInput;
      this.setIn = setInterval(() => {
        if (this.isTokenDoor === true) {
          clearInterval(this.setIn);
          this.getBannerList();
          this.getProgramList();
          this.getSolutionList();
        }
      }, 500);
    },
    watch: {
      searchtitle() {
        if (this.timer) {
          clearTimeout(this.timer);
        }
        this.timer = setTimeout(() => {
          this.getSolutionList();
        }, 100);
      },
    },
    computed: {
      ...mapState({
        isTokenDoor: "isTokenDoor",
      }),
    },
    mounted() {
      window.scrollTo(0, 0);
      window.addEventListener("resize", () => {
        this.imgHeight = this.$refs.image[0].height;
      });
    },
    methods: {
      imgLoad() {
        this.$nextTick(function () {
          // 获取窗口宽度*图片的比例，定义页面初始的轮播图高度
          // this.imgHeight = (document.body.clientWidth * 1) / 4;
          this.imgHeightsetIn = setInterval(() => {
            if (this.imgHeight == 0) {
              this.imgHeight = this.$refs.image[0].height;
              // console.log(5555, this.imgHeight);
            } else {
              clearInterval(this.imgHeightsetIn);
              // console.log(6666, this.imgHeight);
            }
          }, 520);
        });
      },
      getProgramList() {
        let params = {
          name: "",
          survival: this.survival,
          current: 1,
          pageSize: 10,
          type: 'CASE',
        };
        getProgramList(params).then((res) => {
          if (res.success) {
            if (res.data.length > 0) {
              for (let i = 0; i < res.data.length; i++) {
                let leftInfo = {};
                leftInfo.id = res.data[i].uuid;
                leftInfo.title = res.data[i].label;
                this.soluLeft.push(leftInfo);
              }
              this.soluLeft.unshift({id:null,title:'全部案例'})
            }
          }
        });
      },
      getSolutionList() {
        let params = {
          name: this.searchtitle,
          status: this.status,
          programUuid: this.programUuid,
          programName: this.programName,
          current: this.current,
          pageSize: this.pageSize,
          type: 'CASE'
        };
        getSolutionList(params).then((res) => {
          if (res.success) {
            this.solutionList = res.data;
            this.total = res.total;
          }
        });
      },
      getBannerList() {
        let params = {
          groupCode: this.groupCode,
        };
        getBannerList(params).then((res) => {
          this.bannerList = res;
          this.imgLoad();
        });
      },
      // 分页
      handleSizeChange(val) {
        console.log(`每页 ${val} 条`);
        this.pageSize = val;
        this.getSolutionList();
      },
      handleCurrentChange(val) {
        console.log(`当前页: ${val}`);
        this.current = val;
        window.scrollTo(0, 0);
        this.getSolutionList();
      },
      getSoluTabs() {
        this.solutionTitle = "全部";
        this.soluTabsIndex = null;
        this.programUuid = "";
        this.searchtitle = "";
        this.getSolutionList();
      },
      getSoluTbas(i) {
        this.soluTabsIndex = i;
        this.solutionTitle = this.soluLeft[this.soluTabsIndex].title;
        this.programUuid = this.soluLeft[i].id;
        this.searchtitle = "";
        this.getSolutionList();
      },
      getSolutionDetail(uuid) {
        let routeData = this.$router.resolve({
          name: "empowerCaseDetails",
          params: { uuid: uuid },
          query:{type:'cases'}
        });
        window.open(routeData.href, "_blank");
      },
      getCallOur() {
        this.$router.push("/caseDetails?#tabs");
        // this.$router.push({path: '/caseDetails', query:{stage: stage}});
      },
    },
  };
  </script>

  <style scoped lang="less">
  .blue {
    color: #009999;
  }

  .gray {
    color: #777;
    margin-right: 5px;
  }

  .soluBanner {
    // height: 500px;
    width: 100%;
    background: #efefef;
    position: relative;

    img {
      // height: 500px;
      width: 100%;
    }

    .soluBanBox {
      position: absolute;
      top: 50%;
      left: 50%;
      width: 1200px;
      transform: translate(-50%, -50%);
      color: #fff;

      h2 {
        font-size: 38px;
        letter-spacing: 10px;
      }

      .soluBanText {
        margin: 8px 0 60px;

        p:nth-child(1) {
          font-size: 17px;
        }

        p:nth-child(2) {
          font-size: 9px;
        }
      }

      button {
        border: 1px solid #fff;
        border-radius: 30px;
        color: #fff;
        background: none;
        padding: 2px 5px;
      }
    }
  }

  .soluBottomRTit {
    width: 1200px;
    margin: 0 auto;
    padding: 20px 0 0;
    justify-content: space-between;
    align-items: center;

    .soluBottomInput {
      position: relative;

      input {
        border: none;
        background: #efefef;
        padding: 5px 13px;
        border-radius: 30px;
        height: 20px;
        width: 158px;
        font-size: 12px;
        color: #969696;
      }

      i {
        position: absolute;
        right: 5%;
        top: 50%;
        color: #969696;
        transform: translate(0, -50%);
      }
    }

    .soluBottomRTit2 {
      text-align: left;
      font-size: 28px;
      font-weight: 600;
      color: #1d1d1d;
    }

    .soluRightBtn {
      font-size: 14px;
      color: #6e6e6e;
      display: flex;
      align-items: center;
      font-weight: 400;
      .solutHome{
        cursor: pointer;
      }

      .solutionTitle {
        margin-left: 8px;
        color: rgba(0, 0, 0, 0.88);
      }
    }
  }

  .soluBottom {
    width: 1200px;
    margin: 0 auto;

    .soluBottomL {
      flex-shrink: 0;
      position: relative;

      .solutImgs {
        position: absolute;
        bottom: 0;
        right: 0;
      }

      .soluBottomLTit {
        font-size: 14px;
        cursor: pointer;
        height: 40px;
        line-height: 40px;
        display: flex;
        align-items: center;
        justify-content: center;
        margin: 30px 0;
        width: 237px;
        background: #009999;
        color: #fff;
        border-radius: 0 20px 20px 0;
      }

      .soluBottomLtab {
        display: flex;
        align-items: center;
        font-size: 14px;
        text-align: center;
        border-bottom: 1px solid #E1E1E1;
        margin-bottom: 30px;
        p {
          cursor: pointer;
          color: rgba(0, 0, 0, 0.88);
          height: 40px;
          line-height: 40px;
          display: flex;
          align-items: center;
          justify-content: center;
          padding: 14px 0;
          padding-bottom: 5px;
          width: 237px;
          font-weight: 500;
          // span {
          //   margin-right: 10px;
          // }
          span{

            padding-bottom:10px
          }
        }

        p:nth-last-child(1) {
          border-bottom: none;
        }

        .p_active {
          color: #009999;
          border-bottom: 2px solid #009999;
          padding-bottom:10px

        }
      }

      // .soluBottomLtab_active {
      //   background: #009999;
      //   height: 15px;
      //   width: 3px;
      //   display: inline-block;
      // }
    }

    .soluBottomR {
      margin-left: 28px;
      width: 100%;

      .suluBottomBig2 {
        margin-left: 28px;
        width: 100%;
        text-align: center;
        font-size: 30px;
        font-weight: bold;
        color: #d4d4d4;
        line-height: 650%;
      }

      .suluBottomBig {
        // flex-wrap: wrap;
        // justify-content: space-between;
        display: grid;
        grid-template-columns: 342px 342px 342px;
        grid-column-gap: 30px;
        grid-row-gap: 30px;

        .soluBottomRList {
          width: 344px;
          height: 274px;
          background: #F2F2F2;
          cursor: pointer;
          // background: #fff;
          margin-bottom: 18px;
          // padding: 15px;
          position: relative;

          // height: 120px;
          .soluBottomRImg {
            // margin-top: 15px;
            width: 342px;
            height: 173px;

            flex-shrink: 0;

            img {
              width: 100%;
              height: 100%;
              object-fit: cover;
            }
          }

          .soluBottomRMess {
            margin: 12px 11px;
            margin-bottom: 0;
            h4 {
              font-size: 16px;
              font-family: PingFangSC-Regular, PingFang SC;
              color: #000000;
              line-height: 22px;

            }

            .soluBottomRMess_p {
              color: #777;
              font-size: 14px;
              font-family: PingFangSC-Regular, PingFang SC;
              font-weight: 400;
              color: #6E6E6E;
              line-height: 24px;
              margin-top: 5px;
              display: -webkit-box;
              overflow: hidden;
              white-space: normal !important;
              text-overflow: ellipsis;
              word-wrap: break-word;
              -webkit-line-clamp: 2;
              -webkit-box-orient: vertical;
            }


          }
        }
        .soluBottomRMess_div {
              font-size: 12px;
              color: #b7b7b7;
              align-items: center;

              .soluBottomRMess_div2 {
                align-items: center;
                margin-left: 10px;

                i {
                  margin-right: 5px;
                }
              }
            }
        // .soluBottomRList:hover {
        //   box-shadow: 0px 1px 7px 0px #dadada;
        // }
      }

      .pageina {
        margin-top: 74px;
        text-align: right;

        /deep/.el-pagination button:disabled {
          background-color: transparent;
          border: 1px solid #efefef;
          border-radius: 5px;
        }

        /deep/.el-pagination .btn-prev {
          padding-right: 0;
        }

        /deep/.el-pager li {
          border: 1px solid #efefef;
          border-radius: 5px;
          margin: 0 5px;
        }

        /deep/.el-pager li.active {
          border: 1px solid #009999;
          color: #009999;
        }

      }
    }
  }
  </style>



// WEBPACK FOOTER //
// src/components/cases/cases.vue